import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'

import { CampaignPlatformTypeEnum } from 'src/Types/campaigns'
import { StripePayment } from 'src/Types/payments'
import { api } from 'src/Services/api'
import { APP } from 'src/Configs/App'
import { refetchUsersMe } from 'src/Redux/userInfoApi'

import { ErrorCode, NameSpace } from '../types'

interface ChargePaypalPaymentRequestI {
  amount: number
  campaigns: Array<{
    type: CampaignPlatformTypeEnum
    genres?: number[]
    languages?: number[]
    amount: number
    startDate: string
    campaignId: number
    isMedianTest?: boolean
  }>
  country: string
  couponValue?: string
  usedBalance: number
}

export const chargePaypalPayment = createAsyncThunk<
  { link: string },
  ChargePaypalPaymentRequestI
>(
  `${NameSpace.Payment}/chargePaypalPayment`,
  async (requestData, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await api.post<{ link: string }>(
        `${APP.TIKTOK_SERVER}/artist/payments/paypal/charge`,
        requestData,
      )

      await dispatch(refetchUsersMe())
      return data
    } catch (error) {
      const { message, response } = error as AxiosError
      return rejectWithValue({
        message,
        code: response?.status || ErrorCode.InternalServerError,
      })
    }
  },
)

export const submitStripePayment = createAsyncThunk<
  { link: string },
  StripePayment
>(
  `${NameSpace.Payment}/submitStripePayment`,
  async (requestData, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await api.post<{ link: string }>(
        `${APP.TIKTOK_SERVER}/payment/stripe/create-session`,
        requestData,
      )
      await dispatch(refetchUsersMe())
      return data
    } catch (error) {
      const { message, response } = error as AxiosError
      return rejectWithValue({
        message,
        code: response?.status || ErrorCode.InternalServerError,
      })
    }
  },
)
